import MetaParser from './MetaParser';

class PassportParser extends MetaParser implements Passport {
  first_name = '';
  last_name = '';
  date_of_birth = '';
  front_image_url = '';
  date_of_travel = '';
  date_of_return = '';
  obj_id = '';
  back_image_url = '';
  scanned = false;
  number = '';
  expiration_date = '';
  country = '';
  raw_front_image = '';
  portrait_picture_url = '';
  visitor?: Visitor;
  _gender = '';
  father_name = '';
  mothers_name = '';

  constructor(passport: Passport, visitor?: Visitor) {
    super();
    this.visitor = visitor;
    this.util.assign(this, passport);
  }

  get id() {
    return this.obj_id;
  }

  get front_img() {
    return this.parseImage(this.front_image_url);
  }

  get back_img() {
    return this.parseImage(this.back_image_url);
  }

  get name() {
    return this.first_name || this.visitor?.first_name;
  }

  get surname() {
    return this.last_name || this.visitor?.last_name;
  }

  get place_of_issue() {
    return this.country;
  }

  get gender_code() {
    return this.getGenderCode(this.gender);
  }

  get passport_number() {
    return this.number;
  }

  get dob() {
    return this.date_of_birth || this.visitor?.date_of_birth;
  }

  get expiry_date() {
    return this.expiration_date;
  }

  get gender() {
    return this._gender || this.visitor?.gender || '';
  }

  set gender(value) {
    this._gender = value;
  }

  get photograph() {
    return this.parseImage(this.portrait_picture_url);
  }
}

export default PassportParser;
